import React from 'react'

const JS = () => {
  return (
    <div>JS</div>
  )
}

export default JS